export default __webpack_public_path__ + "static/media/banner_image.15274e86.jpg";